import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, ArrowRight } from 'lucide-react';
export function CTASection() {
  return <section id="reserva" className="py-24 bg-inkova-primary text-white relative overflow-hidden" data-id="element-104">
      {/* Background image with overlay */}
      <div className="absolute inset-0 z-0" data-id="element-105">
        <img src="https://cdn.magicpatterns.com/uploads/nRJ6M1dcskrTPaimxkkmRX/ddd61cf5-9214-43f7-a987-6957f92ed66c.jpg" alt="Inkova Background" className="w-full h-full object-cover opacity-20" style={{
        objectPosition: 'center 20%'
      }} data-id="element-106" />
        <div className="absolute inset-0 bg-gradient-to-b from-inkova-primary/90 via-inkova-primary/80 to-inkova-primary" data-id="element-107"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-108">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-109">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-serif mb-8 text-white leading-tight" data-id="element-110">
            Ya tienes la&nbsp;idea.
            <br data-id="element-111" />
            <span className="text-inkova-accent" data-id="element-112">
              Ya tienes las&nbsp;ganas.
            </span>
          </h2>

          <p className="text-xl sm:text-2xl text-gray-200 mb-4 font-light" data-id="element-113">
            Solo falta la&nbsp;estructura.
          </p>
          <p className="text-xl sm:text-2xl text-white font-bold mb-12" data-id="element-114">
            Y para eso estamos&nbsp;nosotros.
          </p>

          <div className="bg-white/10 p-8 rounded-3xl backdrop-blur-sm border border-white/20 mb-12 max-w-2xl mx-auto" data-id="element-115">
            <p className="text-lg md:text-xl text-gray-200 mb-8 font-light" data-id="element-116">
              El primer paso es simple: Una conversación. Sin compromiso.
              Con&nbsp;claridad.
            </p>

            <a href="https://inkovacreation.store/shop/341dc5f2-2e37-4bec-89a7-31063f77eefd" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 rounded-full bg-inkova-accent text-inkova-primary font-bold text-lg hover:bg-white transition-all duration-300 shadow-xl w-full sm:w-auto" data-id="element-117">
              Reserva sesión estratégica
              <ArrowRight className="ml-3 w-5 h-5" data-id="element-118" />
            </a>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-gray-300 font-light" data-id="element-119">
          <p className="mb-6 text-lg" data-id="element-120">¿Prefieres escribirnos&nbsp;primero?</p>

          <div className="flex flex-col sm:flex-row justify-center items-center gap-6 sm:gap-12" data-id="element-121">
            <a href="mailto:inkovallc@gmail.com" className="flex items-center hover:text-white transition-colors" data-id="element-122">
              <Mail className="w-5 h-5 text-inkova-accent mr-3" data-id="element-123" />
              inkovallc@gmail.com
            </a>
            <a href="https://wa.me/17863037695" target="_blank" rel="noopener noreferrer" className="flex items-center hover:text-white transition-colors" data-id="element-124">
              <Phone className="w-5 h-5 text-inkova-accent mr-3" data-id="element-125" />
              WhatsApp: +1 (786) 303‑7695
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}